import { React, useState, useEffect } from "react";
import "./resources.css";
import { Image, Alert, Button, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getAllBlogsByPartner, deleteBlogById } from "../../api/axios";
import CmsCircularProgress from "../../Components/Common/CircularProgress";
import styled from "styled-components";
import { showToast } from "../../Utills/toast";
import CustomTable from "../../Components/Common/DataTable/DataTable";

function Preview() {
  const {partnerId} = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  
  const fetchAllBlogsByPartner = async () => {
    setIsLoading(true);
    try {
      const res = await getAllBlogsByPartner(partnerId);
      const blogData = res.data.data;
      setData(blogData);
    } catch (err) {
      showToast({
        type: 'error',
        message: err?.response?.data?.message || 'Failed to fetch blogs. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  }
      
  useEffect(() => {
    fetchAllBlogsByPartner();
  }, []);

  const handleEditClick = (id) => {
    navigate(`update/${id}`);
    console.log("clicked");
  };

  const handleDeleteClick = async (id) => {
    try {
      const res = await deleteBlogById(id);
      if (res.status === 200) {
        setShowAlert(false);
        setBlogToDelete(null);
        showToast({
          type: 'success',
          message: res?.data?.message || 'Blog deleted successfully!',
        });
        window.location.reload();
      } else {
        showToast({
          type: 'error',
          message: res?.data?.message || 'Failed to delete blog. Please try again.',
        });
      }
    } catch (err) {
      showToast({
        type: 'error',
        message: err?.response?.data?.message || 'Failed to delete blog. Please try again.',
      });
      console.error(err);
    }
  };

  const handleDeleteButtonClick = (blogId) => {
    setBlogToDelete(blogId);
    setShowAlert(true);
  };

  const columns= [
    {
      text: "Blog ID",
      width: "50px"
    },
    {
      text: "Image",
      width: "15vw"
    },
    {
      text: "Title",
      width: "85px"
    },
    {
      text: "Content",
      width: "450px"
    },
    {
      text: "Read More",
      width: "210px"
    },
    {
      text: "Actions",
      width: "100px"
    }
  ]

  const rows = [];

  if (data?.length > 0) {
    data.forEach((blog) => {
      rows.push([
        blog.id,
        <Image src={blog.blog_img} alt={`blog_image${blog.id}`} style={{ maxWidth: "15vw" }} />,
        blog.blog_title,
        blog.blog_content,
        blog.blog_readMore, 
        (
         <div style={{display: "flex", gap: "10px"}}>
          <Button variant="primary" className="w-auto m-0" onClick={() => handleEditClick(blog.id)}>Edit</Button>
          <Button variant="danger" className="w-auto m-0" onClick={() => handleDeleteButtonClick(blog.id)}>Delete</Button>
         </div>
        )
        
      ]);
    });
  }
  

  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
    <>
    <CustomTable columns={columns} rows={rows} />
    <TableWrapper>
      {showAlert && (
                <>
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      zIndex: 100,
                    }}
                  ></div>
                  <Alert
                    variant="danger"
                    onClose={() => {
                      setShowAlert(false);
                      setBlogToDelete(null);
                    }}
                    dismissible={false}
                    style={{
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      maxWidth: '456px',
                      width: 'calc(100vw - 8vw)',
                      height: "auto",
                      zIndex: 1000,
                      backgroundColor: "#f5c2c7",
                    }}
                  >
                    <Alert.Heading
                      style={{
                        fontSize: "1.5rem",
                        color: "#842029",
                        textAlign: "center",
                      }}
                    >
                      Confirm Delete
                    </Alert.Heading>

                    <p style={{ textAlign: "center", color: "#842029" }}>
                      Are you sure you want to delete this blog?
                    </p>
                    <div
                      className="d-flex justify-content-end"
                      style={{ display: "grid", gridGap: "10px" }}
                    >
                      <Button
                        style={{ color: "white" }}
                        className="btn btn-danger mb-3 mr-2"
                        onClick={() => handleDeleteClick(blogToDelete)}
                      >
                        Yes
                      </Button>
                      <Button
                        className="btn mb-3 btn-secondary"
                        onClick={() => {
                          setShowAlert(false);
                          setBlogToDelete(null);
                        }}
                      >
                        No
                      </Button>
                    </div>
                  </Alert>
                </>
              )}
    </TableWrapper>
    </>
    }
    </>
  );
}

export default Preview;

const TableWrapper = styled.div`
  overflow-x: auto;
    max-width: 94vw;
`;
